//import { AccountRecoveryOptions } from "./_components/account-recovery-options"
import { ChangePassword } from "./components/change-password"
//import { RecentLogs } from "./_components/recent-logs"
//import { SecurityPreferences } from "./_components/security-preferences"

export default function SecurityPage() {
  return (
    <div className="grid gap-4">
      <ChangePassword />
        {/** <SecurityPreferences user={userData} /> **/}
       {/** <AccountRecoveryOptions user={userData} /> **/}
        {/** <RecentLogs /> **/}
    </div>
  )
}